<template>
  <div class="manager-documento">
    <div>
      <PageTitle
        isBack="true"
        link="rh"
        fontSize="25"
        icon="fa fa-file"
        title="Recursos Humanos // Documentos Digitais"
      />
    </div>
    <!-- filtros da lista -->
    <div class="container-documento" v-if="!loading">
      <div>
        <div>
          <label>Tipo de Documento</label>
          <vs-select width="430px" autocomplete v-model="tipoDocumento">
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in tipoDocumentoData"
            />
          </vs-select>
        </div>
        <div style="display: flex; flex-direction: column; margin-left: 8px">
          <label>Data Base</label>
          <input class="input-data" type="date" v-model="dataBase" />
        </div>
        <div style="display: flex; flex-direction: column; margin-left: 8px">
          <label>Data Limite</label>
          <input class="input-data" type="date" v-model="dataLimite" />
        </div>
      </div>
      <div style="margin-top: 20px">
        <uploader
          @uploader="arquivo = $event"
          @remover="removeArquivoupload($event)"
        />
      </div>
      <div class="container-salvar" v-if="!loading">
        <vs-button
          color="success"
          style="width: 1108px"
          type="filled"
          @click="clickSalvaArquivo"
          >Processar arquivo digital na ClickSign</vs-button
        >
      </div>
    </div>

    <div class="load-arquivo" v-if="loading">
      <img src="@/assets/load-file.jpg" width="350px" />
      <span>Processando arquivo na ClickSign ...</span>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { baseApiUrlRH } from "@/global";

import PageTitle from "@/components/template/PageTitle";

import Uploader from "./Upload";

//eventos
import { EventBusLogged } from "@/eventBus/eventBusLogged";

//configuração das mensagens
const configMessageNo = {
  iconPack: "fontawesome",
  position: "top-center",
  className: ["toast-global"],
  type: "error",
  duration: 11000,
};

const configMessageYes = {
  iconPack: "fontawesome",
  position: "top-center",
  className: ["toast-global"],
  type: "success",
  duration: 11000,
};

export default {
  name: "DocumentosDigitais",
  components: { PageTitle, Uploader },
  data() {
    return {
      loading: false,
      tipoDocumentoData: [
        { value: 1, text: "Recibo de Férias" },
        { value: 2, text: "Espelho de Ponto" }
      ],
      tipoDocumento: null,
      dataBase: null,
      dataLimite: null,
      arquivo: null,
    };
  },

  methods: {
    async clickSalvaArquivo() {
      const dataAtual = new Date().toISOString().split("T")[0];
      
      if (!this.tipoDocumento) {
        this.$toasted.show(`Selecione o tipo de documento! `, configMessageNo);
        return;
      }

      if (!this.dataBase) {
        this.$toasted.show(`A data base é obrigatória! `, configMessageNo);
        return;
      }

      if (this.tipoDocumento == 1 && this.dataBase < dataAtual) {
        this.$toasted.show(
          `A data base não pode ser menor que a data atual! `,
          configMessageNo
        );
        return;
      }

      if (this.dataLimite && this.dataLimite <= dataAtual) {
        this.$toasted.show(
          `A data limite deve ser posterior a data de hoje! `,
          configMessageNo
        );
        return;
      }

      if (!this.arquivo) {
        this.$toasted.show(
          `Faça o uplod do arquivo para salvar o documento! `,
          configMessageNo
        );
        return;
      }

      const headers = {
        "Content-Type": "multipart/form-data",
      };

      let formData = new FormData();
      formData.append("tipoDocumentoId", this.tipoDocumento);
      formData.append("dataBase", this.dataBase);
      formData.append("dataLimite", this.dataLimite);
      formData.append("arquivo", this.arquivo);
      
      this.loading = true;

      await axios
        .post(`${baseApiUrlRH}/documento-digital`, formData, headers)
        .then((resp) => {
          console.log(resp);
          if (!resp.data.error) {
            this.limparFormulario();
          }
          this.$toasted.show(
            resp.data.message,
            resp.data.error ? configMessageNo : configMessageYes
          );
        })
        .catch(() => {
          this.loading = false;
        });

      this.loading = false;
    },

    removeArquivoupload() {
      this.arquivo = null;
    },

    limparFormulario() {
      this.tipoDocumento = null;
      this.dataBase = null;
      this.dataLimite = null;
      this.arquivo = null;

      EventBusLogged.$emit("limpar_uploader");
    },
    async processamentoStatus() {
      await axios
        .get(`${baseApiUrlRH}/documento-digital/processando`)
        .then((resp) => {
          this.loading = resp.data ? true : false;
        });
    },
  },
  mounted() {
    this.processamentoStatus();
  },
};
</script>

<style scoped src="./style.css"></style>
